import computeAutoPlacement from './computeAutoPlacement';
import debounce from './debounce';
import findIndex from './findIndex';
import getBordersSize from './getBordersSize';
import getBoundaries from './getBoundaries';
import getBoundingClientRect from './getBoundingClientRect';
import getClientRect from './getClientRect';
import getOffsetParent from './getOffsetParent';
import getOffsetRect from './getOffsetRect';
import getOffsetRectRelativeToCustomParent from './getOffsetRectRelativeToCustomParent';
import getOuterSizes from './getOuterSizes';
import getParentNode from './getParentNode';
import getPopperOffsets from './getPopperOffsets';
import getPosition from './getPosition';
import getReferenceOffsets from './getReferenceOffsets';
import getScroll from './getScroll';
import getScrollParent from './getScrollParent';
import getStyleComputedProperty from './getStyleComputedProperty';
import getSupportedPropertyName from './getSupportedPropertyName';
import getTotalScroll from './getTotalScroll';
import getWindowSizes from './getWindowSizes';
import includeScroll from './includeScroll';
import isFixed from './isFixed';
import isFunction from './isFunction';
import isModifierEnabled from './isModifierEnabled';
import isModifierRequired from './isModifierRequired';
import isNative from './isNative';
import isNumeric from './isNumeric';
import isTransformed from './isTransformed';
import removeEventListeners from './removeEventListeners';
import runModifiers from './runModifiers';
import setAttributes from './setAttributes';
import setStyles from './setStyles';
import setupEventListeners from './setupEventListeners';

/** @namespace Popper.Utils */
export default {
    computeAutoPlacement,
    debounce,
    findIndex,
    getBordersSize,
    getBoundaries,
    getBoundingClientRect,
    getClientRect,
    getOffsetParent,
    getOffsetRect,
    getOffsetRectRelativeToCustomParent,
    getOuterSizes,
    getParentNode,
    getPopperOffsets,
    getPosition,
    getReferenceOffsets,
    getScroll,
    getScrollParent,
    getStyleComputedProperty,
    getSupportedPropertyName,
    getTotalScroll,
    getWindowSizes,
    includeScroll,
    isFixed,
    isFunction,
    isModifierEnabled,
    isModifierRequired,
    isNative,
    isNumeric,
    isTransformed,
    removeEventListeners,
    runModifiers,
    setAttributes,
    setStyles,
    setupEventListeners,
};
